export default __webpack_public_path__ + "static/media/MessageText.75233a6c.txt";